import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScreenShareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"screen_share"}/>
}
